export function* reverseIteratorGen<T>(arr: T[]) {
	for (let i = arr.length - 1; i > 0; i--) {
		const item = arr[i];

		if (item) {
			yield item;
		}
	}
}

export function reverseIterator<T>(arr: T[]): IterableIterator<T> {
	let i = arr.length;

	function next(): IteratorResult<T> {
		if (i > 0) {
			i--;
			return { done: false, value: arr[i] as T };
		}

		return { done: true, value: undefined };
	}

	return {
		next,
		[Symbol.iterator]() {
			return this;
		},
	};
}
